import React from 'react';

const TopStoryDots = ({ totalSections, currentSection, onSectionChange }) => {
  if (totalSections === 0) return null;

  return (
    <div className="fixed top-4 left-0 right-0 z-100 flex justify-center gap-1 px-4">
      <div className="flex gap-1 max-w-screen-sm w-full">
        {Array.from({ length: totalSections }).map((_, index) => (
          <button
            key={index}
            onClick={() => onSectionChange(index)}
            className="flex-1 h-1 rounded-full transition-all duration-300 hover:h-1.5"
            style={{
              background: index === currentSection
                ? 'rgba(255, 255, 255, 0.9)'
                : 'rgba(255, 255, 255, 0.3)',
              backdropFilter: 'blur(4px)',
            }}
            aria-label={`Go to section ${index + 1}`}
            aria-current={index === currentSection ? 'true' : 'false'}
          />
        ))}
      </div>
    </div>
  );
};

export default TopStoryDots;
